import * as React from "react";
import { css } from "@emotion/core";
import {
  Alignment,
  Alert,
  Button,
  Card,
  Navbar,
  Intent,
  NavbarGroup,
  Tag,
  Popover,
  PopoverInteractionKind,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import ApiLayers from "api/layers";
import { useControlledInput } from "hooks/";
import { withPreventDefault } from "utils/";

const CreateAttributeLabel = ({ layer }) => {
  const [readyToRemoveId, setReadyToRemoveId] = React.useState(null);
  const {
    valid: $label,
    reset: resetName,
    ...label
  } = useControlledInput((v) => {
    if (!v) return false;
    if (layer.attributes) {
      return layer.attributes.map((a) => a.label).includes(v) === false;
    } else {
      return true;
    }
  });

  return (
    <>
      {layer.attributes.length > 0 && (
        <section
          css={css`
            padding: 1rem;
          `}
        >
          {layer.attributes.map((attribute) => (
            <Tag
              css={css`
                margin-right: 5px;
                margin-bottom: 5px;
              `}
              key={attribute.label}
              onRemove={() => setReadyToRemoveId(attribute.id)}
            >
              {attribute.label}
            </Tag>
          ))}
        </section>
      )}
      {/*
      <Navbar>
        <NavbarGroup>
          <Popover
            position="left"
            interactionKind={PopoverInteractionKind.HOVER}
            content={
              <Card>
                <FormGroup
                  label="Attribute Label"
                  labelFor="attribute-label"
                  labelInfo="(required)"
                >
                  <InputGroup id="attribute-label" {...label} />
                </FormGroup>
                <Button
                  text="Create Attribute"
                  intent="primary"
                  onClick={() => {
                    ApiLayers.createAttributeLabel(layer.id, label.value).then(
                      resetName
                    );
                  }}
                />
              </Card>
            }
          >
            <Button
              icon="add"
              text="Add Descriptive Attribute"
              intent="primary"
            />
          </Popover>
        </NavbarGroup>
      </Navbar>
      */}
      {readyToRemoveId && (
        <Alert
          className="bp6-dark"
          cancelButtonText="Cancel"
          confirmButtonText="Remove Annotation Attribute"
          icon="trash"
          intent={Intent.DANGER}
          isOpen={readyToRemoveId !== null}
          onCancel={() => setReadyToRemoveId(null)}
          onConfirm={() => {
            const id = readyToRemoveId;
            setReadyToRemoveId(null);
            ApiLayers.removeAttributeLabel(id);
          }}
        >
          <p>
            Are you sure you would like to remove the label{" "}
            <strong>
              {
                layer.attributes.find(
                  (attribute) => attribute.id === readyToRemoveId
                ).label
              }
            </strong>
            ? The attribute will be removed from all annotations on this layer.
          </p>
        </Alert>
      )}
    </>
  );
};

export default CreateAttributeLabel;
